<template>
	<div v-if="entities && canView" class="grid-flex-container">
		<div class="grid-toolbar mb-4">
			<div class="flex-grow-1">
				<v-tabs @change="onTabItemChanged">
					<v-tab v-for="(entity, index) in entities" :key="index">{{
						entity.Name
					}}</v-tab>
				</v-tabs>
			</div>
			<v-btn v-if="canAdd" color="primary" @click.stop="onAddEntity">
				<v-icon>mdi-plus</v-icon>
				Add
			</v-btn>
		</div>
		<v-container fluid class="pt-0">
			<div style="flex-grow: 1">
				<v-text-field
					v-model="search"
					class="py-0 my-0 mb-2"
					append-icon="mdi-magnify"
					label="Search"
					single-line
					hide-details
				></v-text-field>
			</div>
		</v-container>
		<div class="generic-grid-container">
			<v-data-table
				:headers="headers"
				:items="items"
				:search="search"
				:disable-pagination="true"
				item-key="Id"
				fixed-header
				dense
				:loading="loading"
				hide-default-footer
				loading-text="Loading..."
			>
				<template v-slot:[`item.Editable`]="{ item }">
					<v-icon color="primary" v-if="item.Editable"
						>mdi-check-circle</v-icon
					>
				</template>
				<template v-slot:[`item.InUse`]="{ item }">
					<v-icon color="primary" v-if="item.InUse"
						>mdi-check-circle</v-icon
					>
				</template>
				<template v-slot:[`item.DataType`]="{ item }">
					{{ getDataTypeString(item) }}
				</template>
				<template v-slot:[`item.HasIndex`]="{ item }">
					<v-switch
						v-if="canEdit"
						v-model="item.HasIndex"
						class="ma-0 pa-0"
						color="primary"
						@change="onHasIndexChanged(item)"
					>
						<template v-slot:label></template>
					</v-switch>
				</template>
			</v-data-table>
		</div>
		<add-entity-modal
			v-if="showAddEntityModal"
			:showDialog="showAddEntityModal"
			:entities="entities"
			@close="onAddEntityModalClose"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { DataFieldsGetters } from '../../../store/getters';
import { GeneralActions, DataFieldsActions } from '../../../store/actions';
import AddEntityModal from './AddEntityModal.vue';
import { FieldDataTypes } from '../../../enums/fieldDataTypes';
import permissionsMixin from '../../../mixins/permissionsMixin';
import { Permissions } from '../../../enums/permissionsEnum';

export default {
	components: { AddEntityModal },
	name: 'DataFields',
	mixins: [permissionsMixin],
	data() {
		return {
			search: '',
			headers: [
				{ text: 'Field Name', sortable: false, value: 'FieldName' },
				{ text: 'Label', sortable: false, value: 'Label' },
				{ text: 'Data Type', sortable: false, value: 'DataType' },
				{ text: 'Entity', sortable: false, value: 'EntityName' },
				{ text: 'Editable', sortable: false, value: 'Editable' },
				{ text: 'In Use', sortable: false, value: 'InUse' },
				{ text: 'Indexable', sortable: false, value: 'HasIndex' },
			],
			selectedEntity: null,
			showAddEntityModal: false,
		};
	},
	computed: {
		...mapGetters({
			loading: [DataFieldsGetters.GRID_LOADING],
			items: [DataFieldsGetters.DATA],
			entities: [DataFieldsGetters.GET_ENTITIES],
		}),
		canView() {
			return this.hasPermissions([Permissions.Settings.DataFields.View]);
		},
		canAdd() {
			return this.hasPermissions([Permissions.Settings.DataFields.Add]);
		},
		canEdit() {
			return this.hasPermissions([Permissions.Settings.DataFields.Edit]);
		},
	},
	created() {
		if (!this.canEdit) this.headers.splice(6, 1);

		this.$store.dispatch(GeneralActions.LOADING, true);
		this.$store.dispatch(DataFieldsActions.LOAD_ENTITIES).then(() => {
			this.$store.dispatch(GeneralActions.LOADING, false);
		});
	},
	destroyed() {
		this.$store.dispatch(DataFieldsActions.CLEAR);
	},
	methods: {
		getDataTypeString(item) {
			switch (item.DataType) {
				case FieldDataTypes.NUMBER:
					return 'Number';
				case FieldDataTypes.AMOUNT:
					return 'Amount';
				case FieldDataTypes.BOOLEAN:
					return 'Boolean';
				case FieldDataTypes.DATETIME:
					return 'Date & Time';
				case FieldDataTypes.DATE:
					return 'Date';
				case FieldDataTypes.LONG_TEXT:
					return 'Long Text';
				case FieldDataTypes.FILE:
					return 'File';
				case FieldDataTypes.USER:
					return 'User';
				case FieldDataTypes.APPROVAL_STATUS:
					return 'Approval Status';
				case FieldDataTypes.DOUBLE:
					return 'Double';
				case FieldDataTypes.AUTOGENERATED_UNIQUEIDENTIFIER:
					return 'Auto Generated Unique Identifier';
				case FieldDataTypes.AUTOGENERATED_NUMBER:
					return 'Auto Generated Numeric';
				case FieldDataTypes.AUTOGENERATED_DATETIME:
					return 'Auto Generated Date & Time';
				case FieldDataTypes.AUTOGENERATED_BOOLEAN:
					return 'Auto Generated Boolean';
				case FieldDataTypes.UNIQUE_IDENTIFIER:
					return 'Unique Identifier';
				default:
					return 'Text';
			}
		},

		onTabItemChanged(e) {
			this.selectedEntity = this.entities[e];
			this.$store.dispatch(
				DataFieldsActions.LOAD_SELECTED_ENTITY,
				this.selectedEntity
			);
		},
		onHasIndexChanged(item) {
			if (item.HasIndex) {
				this.$store.dispatch(DataFieldsActions.CREATE_INDEX, item);
			} else {
				this.$store.dispatch(DataFieldsActions.REMOVE_INDEX, item);
			}
		},
		onAddEntity() {
			this.showAddEntityModal = true;
		},
		onAddEntityModalClose() {
			this.showAddEntityModal = false;
		},
	},
};
</script>

<style lang="scss">
.v-tabs-bar {
	height: 41px;
}

.v-input--switch {
	.v-input__slot {
		margin-bottom: 0;
	}

	.v-messages {
		display: none;
	}
}
</style>
